import React from 'react'

type GradientTextProps = {
  children: React.ReactNode
  color: string
  fontSize?: string
  fontWeight?: number
}

export const GradientText = (props: GradientTextProps) => {
  const { children, color, fontSize = '.725rem', fontWeight = 700 } = props
  const textStyle: React.CSSProperties = {
    fontSize: fontSize,
    fontWeight: fontWeight,
    fontFamily: 'Montserrat, sans-serif',
    ...(color.includes('gradient')
      ? {
          background: color,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }
      : {
          color: color,
        }),
  }

  return <span style={textStyle}>{children}</span>
}
